import React from 'react';
import { Alert, AlertDescription } from '@lb-classroom/ui';
import { CSSTransition } from 'react-transition-group';
import { AlertCircle, CheckCircle, AlertTriangle, Info } from 'lucide-react';

interface ModalMessageProps {
  message?: string;
  messageType?: string;
}

const getAlertVariant = (type?: string) => {
  switch (type) {
    case 'error':
      return 'destructive';
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    default:
      return 'default';
  }
};

const getAlertIcon = (type?: string) => {
  const iconClass = 'h-4 w-4';
  switch (type) {
    case 'error':
      return <AlertCircle className={iconClass} />;
    case 'success':
      return <CheckCircle className={iconClass} />;
    case 'warning':
      return <AlertTriangle className={iconClass} />;
    default:
      return <Info className={iconClass} />;
  }
};

const ModalMessage: React.FC<ModalMessageProps> = (props) => {
  const { message = '', messageType } = props;
  if (message.length > 0) {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div id="modal-message-container">
          <Alert variant={getAlertVariant(messageType)}>
            {getAlertIcon(messageType)}
            <AlertDescription>{message}</AlertDescription>
          </Alert>
        </div>
      </CSSTransition>
    );
  } else {
    return (
      <CSSTransition appear={true} timeout={500}>
        <div id="modal-message-container" />
      </CSSTransition>
    );
  }
};

export default ModalMessage;
